import { useMemo } from "react";
import useAuth from "common/hooks/useAuth";

export const useUserPermissions = (myAccount: boolean, editedUser: any) => {
  const { user: currentUser } = useAuth();

  const canManageSectors = useMemo(
    () =>
      (currentUser?.isAdmin ||
        currentUser?.isSuperadmin ||
        ((currentUser?.isManager || currentUser?.isObserver) &&
          currentUser?.administrationPermissions?.sector?.update)) ??
      false,
    [currentUser]
  );

  const canManageUsers = useMemo(
    () =>
      (currentUser?.isAdmin ||
        currentUser?.isSuperadmin ||
        ((currentUser?.isManager || currentUser?.isObserver) &&
          currentUser?.administrationPermissions?.user?.update)) ??
      false,
    [currentUser]
  );

  const canManageCurrentUser = useMemo(
    () =>
      myAccount
        ? true
        : editedUser?.id
        ? (currentUser?.isAdmin ||
            currentUser?.isSuperadmin ||
            ((currentUser?.isManager || currentUser?.isObserver) &&
              currentUser?.administrationPermissions?.user?.update)) ??
          false
        : (currentUser?.isAdmin ||
            currentUser?.isSuperadmin ||
            ((currentUser?.isManager || currentUser?.isObserver) &&
              currentUser?.administrationPermissions?.user?.create)) ??
          false,
    [currentUser, myAccount, editedUser]
  );

  const canManageMyPark = useMemo(
    () => (currentUser?.isAdmin || currentUser?.isSuperadmin) ?? false,
    [currentUser]
  );

  const isEditedUserAboveMe = useMemo(() => {
    if (!editedUser || !currentUser) return false;
    if (currentUser.isSuperadmin) return false;
    if (currentUser.isAdmin && editedUser.role?.id === 3) return true;
    if (
      currentUser.isManager &&
      (editedUser.role?.id === 4 || editedUser.role?.id === 3)
    )
      return true;
    if (currentUser.isObserver && editedUser.role?.id !== 6) {
      return true;
    }
    return false;
  }, [currentUser, editedUser]);

  return {
    canManageSectors,
    canManageUsers,
    canManageCurrentUser,
    canManageMyPark,
    isEditedUserAboveMe,
  };
};

export default useUserPermissions;
